import AxiosClient from "./api";
const Create = (data, config) => {
    return AxiosClient.post("/demoregistration", data, config);
  };

const RegisterApi = {Create};

export default RegisterApi